// Import all of Bootstrap’s JS
import * as bootstrap from 'bootstrap'

// Subtle scroll reveal for elements marked with .reveal-on-scroll
document.addEventListener('DOMContentLoaded', () => {
    const revealItems = document.querySelectorAll(
        '.reveal-on-scroll, .reveal-from-left, .reveal-from-right, .reveal-from-top, .reveal-from-bottom'
    )

    // If IntersectionObserver isn't supported, just show everything
    if (!('IntersectionObserver' in window)) {
        revealItems.forEach((item) => item.classList.add('is-visible'))
        return
    }

    const observer = new IntersectionObserver(
        (entries, obs) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('is-visible')
                    obs.unobserve(entry.target)
                }
            })
        },
        { threshold: 0.15, rootMargin: '0px 0px -10% 0px' }
    )

    revealItems.forEach((item) => observer.observe(item))
})

// Cookie consent banner.
// Google Analytics runs in Consent Mode with analytics_storage denied by default
// (see the gtag snippet in each page's head), so no cookies are written until the
// visitor accepts here. The choice is remembered in localStorage.
document.addEventListener('DOMContentLoaded', () => {
    const STORAGE_KEY = 'cookie-consent'

    const readChoice = () => {
        try {
            return localStorage.getItem(STORAGE_KEY)
        } catch (e) {
            return null
        }
    }

    const saveChoice = (value) => {
        try {
            localStorage.setItem(STORAGE_KEY, value)
        } catch (e) {
            // Private mode / storage disabled: the banner simply reappears next visit
        }
    }

    // Already answered — nothing to show
    if (readChoice()) return

    const banner = document.createElement('div')
    banner.className = 'cookie-banner'
    banner.setAttribute('role', 'dialog')
    banner.setAttribute('aria-live', 'polite')
    banner.setAttribute('aria-label', 'Cookie consent')
    banner.innerHTML = `
        <div class="cookie-banner__inner">
            <p class="cookie-banner__text mb-0">
                I use Google Analytics to see which projects people actually read.
                It sets cookies, so it only runs if you say yes. Declining keeps the site fully usable.
            </p>
            <div class="cookie-banner__actions">
                <button type="button" class="btn btn-sm btn-light" data-consent="denied">Decline</button>
                <button type="button" class="btn btn-sm btn-dark" data-consent="granted">Accept</button>
            </div>
        </div>
    `

    const close = () => {
        banner.classList.remove('is-visible')
        banner.addEventListener('transitionend', () => banner.remove(), { once: true })
        // Fallback in case the transition never fires (reduced motion, hidden tab)
        setTimeout(() => banner.remove(), 500)
    }

    banner.querySelectorAll('[data-consent]').forEach((btn) => {
        btn.addEventListener('click', () => {
            const choice = btn.dataset.consent
            saveChoice(choice)

            if (choice === 'granted' && typeof window.gtag === 'function') {
                window.gtag('consent', 'update', { analytics_storage: 'granted' })
            }

            close()
        })
    })

    document.body.appendChild(banner)
    // Force a reflow so the transition has a starting point, then reveal.
    // (A rAF callback would never run while the tab is in the background, which
    // would leave the banner stuck at opacity 0.)
    void banner.offsetHeight
    banner.classList.add('is-visible')
})

// Start videos at a comfortable 30% volume by default (viewers can still adjust)
document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('video').forEach((video) => {
        video.volume = 0.3
        video.addEventListener('loadedmetadata', () => {
            video.volume = 0.3
        })
    })
})